import React from 'react';
import { Package, AlertTriangle } from 'lucide-react';

interface StockIndicatorProps {
  currentStock: number;
  isAvailable: boolean;
}

const StockIndicator: React.FC<StockIndicatorProps> = ({ currentStock, isAvailable }) => {
  if (!isAvailable) {
    return (
      <div className="flex items-center gap-2 bg-red-50 text-red-700 px-4 py-2 rounded-lg">
        <AlertTriangle size={18} />
        <span className="font-medium">Rupture de stock</span>
      </div>
    );
  }

  // Afficher différents messages en fonction du niveau de stock
  if (currentStock <= 10) {
    return (
      <div className="flex items-center gap-2 bg-amber-50 text-amber-700 px-4 py-2 rounded-lg">
        <Package size={18} />
        <span className="font-medium">Plus que {currentStock} en stock !</span>
      </div>
    );
  }

  if (currentStock <= 50) {
    return (
      <div className="flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-lg">
        <Package size={18} />
        <span className="font-medium">Stock limité : {currentStock} restants</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 bg-green-50 text-green-700 px-4 py-2 rounded-lg">
      <Package size={18} />
      <span className="font-medium">En stock</span>
    </div>
  );
};

export default StockIndicator;